import { propClassName } from '@/styles/TrendingMenu';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { TrendingMenuHeadlineComponent } from './TrendingMenu.Headline';
import { TrendingMenuTagComponent } from './TrendingMenu.Tag';

export interface TrendingMenuProps extends ComponentProps<'section'> {
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

const TrendingMenuComponent: Component<TrendingMenuProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('colors', colors, 'default');
  const sizeClassName = propClassName('size', size, 'default');
  const variantClassName = propClassName('variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <section className={componentClassName} {...props}>
      {children}
    </section>
  );
};

export const TrendingMenu = Object.assign(TrendingMenuComponent, {
  Headline: TrendingMenuHeadlineComponent,
  Tag: TrendingMenuTagComponent,
});
